import React from 'react';
import { useDarkMode } from 'utils/darkMode';
import './Label.css';

/**
 * Label - Form label component
 * 
 * @param {Object} props
 * @param {string} props.htmlFor - ID of associated input
 * @param {boolean} props.required - Show required indicator
 * @param {ReactNode} props.children - Label text
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.variant - Label variant: 'default', 'small', 'uppercase'
 */
const Label = ({
  htmlFor,
  required = false,
  children,
  className = '',
  variant = 'default'
}) => {
  const { isDarkMode } = useDarkMode();

  return (
    <label
      htmlFor={htmlFor}
      className={`label label-${variant} ${isDarkMode ? 'dark-theme' : 'light-theme'} ${className}`}
    >
      {children}
      {required && <span className="label-required">*</span>}
    </label>
  );
};

export default Label;

